// BOTH function are exactly same but two are retained to
// avoid making changes in back code which uses function A
export function getLastNdaysLabel(numOfDays) {
  // OUTPUT '8/11', '7/11', '6/11', '5/11'
  // this function return last 7 days date in dd//mm formate
  let label = [];

  for (let i = 0; i < numOfDays; i++) {
    let d = new Date();

    let decrease = d.getDate() - i;
    d.setDate(decrease);
    let dateString = d.toLocaleDateString("en-In");
    // now we remove year part to get just dd/mm
    let tArr = dateString.split("/");
    tArr.splice(2);
    let finalDateString = tArr.join("/");
    label.push(finalDateString);
  }

  /*
      let date = new Date();

    let d = date.setDate(date.getDate() - i);

    // d.toISOString().split("T").reverse().join("-");
    d = date
      .toISOString()
      .split("T")[0]
      .split("-")
      .reverse()
      .join("/")
      .slice(0, 5);

    // console.log(d);
    result[i] = d;
  }
  // console.log(result);
  return result;
  //console.log(twoDaysAgo.toISOString());

  */

  // console.log(label);

  return label;
}

//BUG ALERT if using d.ISOSTRING() gives us date n time thats 5hrs 30 mins BEHIND so  at midnight of nov 8
// we still get date as nov 7 6:30 pm
export function getLastNdates(days) {
  // OUTPUT format '2024-11-07', '2024-11-06',
  //days is for how many days we need dates starting from d1
  // need to create a label array with following dates between 2 dates.
  //formate of d1   = dd/mm/yyy will not work in new Date() we need yyyy/mm/dd
  // label = ["2024-11-01","2024-11-01","2024-11-01",...]

  let dates = [];

  for (let i = 0; i < days; i++) {
    let d = new Date();

    let decrease = d.getDate() - i;
    d.setDate(decrease);

    // let dateString = d.toISOString().split("T")[0];

    // using toISOString() gives a time thats 330 mins behind our time zone hence using
    let ds = d.toLocaleDateString("en-In");
    let test = ds.split("/");

    // changing the date format from 8/11 to 08/11 so that strings match from DB dates.
    if (test[0].length == 1) {
      test[0] = `0${test[0]}`;
      ds = test.join("/");
    }

    // changing date foramt if month is single digit then change to 02 from 2 ex 01-02-2025
    if (test[1].length == 1) {
      test[1] = `0${test[1]}`;
      ds = test.join("/");
    }
    let newDate = ds.split("/").reverse().join("-");

    // now we remove year part to get just dd/mm
    // let tArr = dateString.split("/");
    // tArr.splice(2);
    // let finalDateString = tArr.join("/");
    dates.push(newDate);
  }

  // console.log(dates);
  return dates;

  //   console.log(Date.parse());
  //   let date1 = new Date(d1);
  //   date1.setDate(date1.getDate() + 15);
  //   console.log();
  //   console.log(new Date(Date.parse(date1.toDateString())));
}

export function getNumOfDaysFromDates(dateArr) {
  if (dateArr != null) {
    //console.log(dateArr);
    let d1 = new Date(dateArr[0]);
    //console.log(d1);

    let d2 = new Date(dateArr[1]);

    let result = d2 - d1 + 1000;

    return result / 86400000;
  }
}
